import { errorMessages } from '../messages';

/**
 * Show the appropriate error message when parsing JQL fails and a custom field rule was expected.
 */
export var handleCustomFieldRuleError = function handleCustomFieldRuleError(intl) {
  return intl.formatMessage(errorMessages.expectingCustomFieldId);
};